var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CourseList',{attrs:{"level-key":"elementaryLevel","fetch-action":"getCourseElementaries","getter-name":"courseElementaries"}})
}
var staticRenderFns = []

export { render, staticRenderFns }